import { FC } from "react";

import { Link as RouterLink } from "react-router-dom";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

import { brandColorTokens } from "@constants";
import { applicationSpaRoutes } from "@shared/constants/routes";

import { ILogoProperties } from "./Logo.types";

import LogoFull from "@public/images/svgs/logo-full.svg";
import LogoSmall from "@public/images/svgs/logo-small.svg";

const Logo: FC<ILogoProperties> = ({ isCompactOnPhone, isInverted, onNavigate }) => {
  const fill = isInverted ? brandColorTokens.text.displayInverted : brandColorTokens.text.display;

  return (
    <Link
      component={RouterLink}
      to={applicationSpaRoutes.myOverview}
      onClick={onNavigate}
      aria-label="TestaViva"
      data-amp-default-track={true}
      data-amp-event-type="header.link.logo"
      sx={{ display: "flex", alignItems: "center" }}
    >
      {isCompactOnPhone && (
        <Box component="span" sx={{ display: { xs: "flex", sm: "none" } }}>
          <LogoSmall fill={fill} width="32" height="20" viewBox="0 0 32 20" />
        </Box>
      )}
      <Box component="span" sx={{ display: isCompactOnPhone ? { xs: "none", sm: "flex" } : "flex" }}>
        <LogoFull fill={fill} width="134" height="16" viewBox="0 0 134 16" />
      </Box>
    </Link>
  );
};

export default Logo;
